import React, { useState } from "react";
import { FaClipboardList, FaEnvelope, FaPhone, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import kudiImage from "./img/soikud.png";
import "./styles/Signup.css";

const Signup = () => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    phone: "",
    email: "",
    requestType: "Üyelik İsteği",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const { name, surname, phone, email, requestType } = formData;

    // Boş alan kontrolü
    if (!name || !surname || !phone || !email || !requestType) {
      setError("Lütfen tüm alanları doldurun.");
      return;
    }

    try {
      // Production'da IIS reverse proxy kullan - /api istekleri otomatik olarak backend'e proxy ediliyor
      const response = await fetch('/api/pending-users', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, date: new Date().toISOString() }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Başvuru gönderilirken bir hata oluştu.");
      }

      setMessage("Başvurunuz alınmıştır. En kısa zamanda tarafınıza dönüş yapılacaktır.");
      setFormData({
        name: "",
        surname: "",
        phone: "",
        email: "",
        requestType: "Üyelik İsteği",
      });
    } catch (err) {
      setError(`Başvuru gönderilirken bir hata oluştu: ${err.message}`);
    }
  };

  return (
    <motion.div
      className="signup-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        className="signup-background"
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <motion.div
          className="signup-box"
          initial={{ y: -50 }}
          animate={{ y: 0 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <img src={kudiImage} alt="Kudi Logo" className="signup-logo" />
          <h2>Üyelik İste</h2>
          {message && (
            <motion.div
              className="message"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {message}
            </motion.div>
          )}
          {error && (
            <motion.div
              className="error"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {error}
            </motion.div>
          )}
          {!message && (
            <form onSubmit={handleSubmit}>
              {["name", "surname", "phone", "email"].map((field, idx) => (
                <motion.div
                  key={idx}
                  className="form-group"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <i className="icon">
                    {field === "phone" ? <FaPhone /> : field === "email" ? <FaEnvelope /> : <FaUser />}
                  </i>
                  <input
                    type={field === "email" ? "email" : "text"}
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    required
                    placeholder={field === "name" ? "Ad" : field === "surname" ? "Soyad" : field === "phone" ? "Telefon Numarası" : "Email"}
                  />
                  <label>{field === "name" ? "Ad" : field === "surname" ? "Soyad" : field === "phone" ? "Telefon Numarası" : "Email"}</label>
                </motion.div>
              ))}
              <motion.div
                className="form-group"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <i className="icon">
                  <FaClipboardList />
                </i>
                <select
                  name="requestType"
                  value={formData.requestType}
                  onChange={handleChange}
                  required
                >
                  <option value="Üyelik İsteği">Üyelik İsteği</option>
                </select>
                <label>Talep Türü</label>
              </motion.div>
              <motion.button
                type="submit"
                className="signup-button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Gönder
              </motion.button>
              <motion.button
                type="button"
                className="login-button"
                onClick={() => navigate("/login")}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Giriş Yap
              </motion.button>
            </form>
          )}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Signup;
